import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

/* Layout */
import Layout from '@/views/layout/Layout'

/** note: Submenu only appear when children.length>=1
 *  detail see  https://panjiachen.github.io/vue-element-admin-site/guide/essentials/router-and-nav.html
 **/

/**
 * hidden: true                   if `hidden:true` will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu, whatever its child routes length
 *                                if not set alwaysShow, only more than one route under the children
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noredirect           if `redirect:noredirect` will no redirect in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 **/
export const constantRoutes = [
  {
    path: '/redirect',
    component: Layout,
    hidden: true,
    children: [
      {
        path: '/redirect/:path(.*)',
        component: () => import('@/views/redirect/index'),
      },
    ],
  },
  {
    path: '/login',
    component: () => import('@/views/login/index'),
    hidden: true,
  },
  {
    path: '/auth-redirect',
    component: () => import('@/views/login/authredirect'),
    hidden: true,
  },
  {
    path: '/404',
    component: () => import('@/views/errorPage/404'),
    hidden: true,
  },
  {
    path: '/401',
    component: () => import('@/views/errorPage/401'),
    hidden: true,
  },
  {
    path: '/',
    redirect: '/dashboard',
    component: Layout,
  },
  {
    path: '/dashboard',
    meta: {
      title: '首页',
      icon: 'home',
    },
    component: () => import('@/views/dashboard/index'),
  },
  {
    path: '/emotions',
    component: Layout,
    redirect: '/emotions/soil/meteor',
    name: 'Emotions',
    meta: {
      title: '四情监测',
      icon: 'emotions',
    },
    children: [
      {
        path: 'soil',
        component: () => import('@/views/four-emotions/soil-monitor/index'), // Parent router-view
        name: 'Soil',
        alwaysShow: true,
        meta: { title: '墒情监测' },
        redirect: '/emotions/soil/meteor',
        hidden: false,
        children: [
          {
            path: 'meteor',
            component: () => import('@/views/four-emotions/soil-monitor/meteor-equip'),
            name: 'Meteor',
            hidden: false,
            meta: { title: '气象设备' },
          },
          {
            path: 'soil-equip',
            component: () => import('@/views/four-emotions/soil-monitor/soil-equip'),
            name: 'SoilEquip',
            hidden: false,
            meta: { title: '墒情设备' },
          },
        ],
      },
      {
        path: 'pest',
        component: () => import('@/views/four-emotions/pest-monitor/index'), // Parent router-view
        alwaysShow: true,
        name: 'Pest',
        meta: { title: '虫情监测' },
        hidden: false,
        redirect: '/emotions/pest/sex',
        children: [
          {
            path: 'sex',
            component: () => import('@/views/four-emotions/pest-monitor/sex-trap'),
            name: 'Sex',
            hidden: false,
            meta: { title: '性诱设备' },
          },
          {
            path: 'http://wlw2.zjtpyun.com/login/redirect?un=cyxnyncj&pd=E10ADC3949BA59ABBE56E057F20F883E&ismd5=1&redirectURL=%2Finsect%2Fv2%2Fimgspage%3Flandid%3D16599&deviceId%3D477138',
            //component: () => import('@/views/four-emotions/pest-monitor/light-trap'),
            //name: 'Light',
            meta: { title: '光诱设备' },
            hidden: false,
          },
          {
            path: 'light',
            component: () => import('@/views/four-emotions/pest-monitor/light-trap'),
            name: 'Light',
            hidden: false,
            meta: { title: '新虫情设备' },
          },
        ],
      },
      {
        path: 'physiological',
        component: () => import('@/views/four-emotions/physiological-monitor/index'), // Parent router-view
        name: 'Physiological',
        alwaysShow: true,
        hidden: false,
        meta: { title: '生理监测' },
        redirect: '/emotions/physiological/growth',
        children: [
          {
            path: 'growth',
            component: () => import('@/views/four-emotions/physiological-monitor/growth-equip'),
            name: 'Growth',
            hidden: false,
            meta: { title: '长势设备' },
          },
        ],
      },
      {
        path: 'disaster',
        component: () => import('@/views/four-emotions/disaster-monitor/index'), // Parent router-view
        name: 'Disaster',
        alwaysShow: true,
        hidden: false,
        meta: { title: '灾情监测' },
        redirect: '/emotions/disaster/time',
        children: [
          {
            path: 'time',
            component: () => import('@/views/four-emotions/disaster-monitor/time-monitor'),
            name: 'Time',
            hidden: false,
            meta: { title: '实时监控' },
          },
        ],
      },
    ],
  },
  {
    path: '/agricultural',
    component: Layout,
    redirect: '/agricultural/plant/crop',
    name: 'Agricultural',
    meta: {
      title: '农事管理',
      icon: 'work',
    },
    children: [
      {
        path: 'plant',
        component: () => import('@/views/agricultural/planting-model/index'), // Parent router-view
        name: 'Plant',
        alwaysShow: true,
        meta: { title: '种植模型' },
        redirect: '/agricultural/plant/crop',
        children: [
          {
            path: 'crop',
            component: () => import('@/views/agricultural/planting-model/crop-growth'),
            name: 'Crop',
            meta: { title: '作物长势' },
          },
        ],
      },
      {
        path: 'production',
        component: () => import('@/views/agricultural/production/index'), // Parent router-view
        alwaysShow: true,
        name: 'Production',
        meta: { title: '生产管理' },
        redirect: '/agricultural/production/agricultural',
        children: [
          {
            path: 'agricultural',
            component: () => import('@/views/agricultural/production/agricultural-management'),
            name: 'Agricultural-1',
            meta: { title: '农事操作' },
          },
          {
            path: 'farming',
            component: () => import('@/views/agricultural/production/farming-operation'),
            name: 'Farming',
            meta: { title: '农资管理' },
          },
          {
            path: 'harvest',
            component: () => import('@/views/agricultural/production/harvest-management'),
            name: 'Harvest',
            meta: { title: '采收管理' },
          },
        ],
      },
      {
        path: 'sales',
        component: () => import('@/views/agricultural/sales/index'), // Parent router-view
        name: 'Sales',
        alwaysShow: true,
        meta: { title: '销售管理' },
        redirect: '/agricultural/sales/inspection',
        children: [
          {
            path: 'inspection',
            component: () => import('@/views/agricultural/sales/inspection-record'),
            name: 'Inspection',
            meta: { title: '检验记录' },
          },
          {
            path: 'trace',
            component: () => import('@/views/agricultural/sales/traceability-management'),
            name: 'Trace',
            meta: { title: '溯源管理' },
          },
          {
            path: 'stock',
            component: () => import('@/views/agricultural/sales/goods-stock'),
            name: 'Stock',
            meta: { title: '商品库存' },
          },
          {
            path: 'customer',
            component: () => import('@/views/agricultural/sales/customer-management'),
            name: 'Customer',
            meta: { title: '客户管理' },
          },
          {
            path: 'sales',
            component: () => import('@/views/agricultural/sales/sales-management'),
            name: 'Sales-1',
            meta: { title: '销售管理' },
          },
        ],
      },
    ],
  },
  {
    path: '/sys',
    component: Layout,
    children: [
      {
        path: '/system',
        component: () => import('@/views/system-stat/index'),
        name: 'system',
        meta: { title: '统计分析', icon: 'statistics' },
      },
    ],
  },
  // {
  //   path: '/knowledge',
  //   component: Layout,
  //   children: [
  //     {
  //       path: '/knowledgebase',
  //       component: () => import('@/views/knowledge/knowledgebase'),
  //       name: 'knowledgebase',
  //       meta: { title: '知识库', icon: 'knowledge'}
  //     }
  //   ]
  // },
  {
    path: '/knowledgebase',
    component: Layout,
    redirect: '/knowledgebase/crop',
    name: 'knowledgebase',
    meta: { title: '知识库', icon: 'knowledge' },
    children: [
      {
        path: '/knowledgebase/crop',
        component: () => import('@/views/knowledge/crop'),
        name: 'crop',
        hidden: false,
        meta: { title: '农作物知识' },
      },
      {
        path: '/knowledgebase/environmental',
        component: () => import('@/views/knowledge/environmental'),
        name: 'environmental',
        hidden: false,
        meta: { title: '农作物环境需求知识' },
      },
      {
        path: '/knowledgebase/farming',
        component: () => import('@/views/knowledge/farming'),
        name: 'farming',
        hidden: false,
        meta: { title: '农事操作知识' },
      },
      {
        path: '/knowledgebase/soil',
        component: () => import('@/views/knowledge/soil'),
        name: 'soil',
        hidden: false,
        meta: { title: '土壤墒情知识' },
      },
      {
        path: '/knowledgebase/pest',
        component: () => import('@/views/knowledge/pest'),
        name: 'pest',
        hidden: false,
        meta: { title: '病虫害知识' },
      },
    ],
  },
  {
    path: '/expert',
    component: Layout,
    children: [
      {
        path: '/expertlibrary',
        component: () => import('@/views/expert/expertlibrary'),
        name: 'system',
        meta: { title: '专家库', icon: 'expert' },
      },
    ],
  },
  {
    path: '/information',
    component: Layout,
    children: [
      {
        path: '/information/index',
        component: () => import('@/views/information/index'),
        name: 'system',
        meta: { title: '资料管理', icon: 'expert' },
      },
    ],
  },
  {
    path: '',
    component: Layout,
    hidden: true,
    children: [
      {
        path: '/setting',
        component: () => import('@/views/setting/index'),
        name: 'setting',
        hidden: true,
        meta: {
          keepAlive: false,
        },
      },
    ],
  },
  {
    path: '',
    component: Layout,
    hidden: true,
    children: [
      {
        path: '/message',
        component: () => import('@/views/message/index'),
        name: 'message',
        hidden: true,
        meta: {
          keepAlive: false,
        },
      },
    ],
  },
  {
    path: '',
    component: Layout,
    hidden: true,
    children: [
      {
        path: '/kdgdetail',
        component: () => import('@/views/knowledge/detail'),
        name: 'kdgdetail',
        hidden: true,
        meta: {
          keepAlive: false,
        },
      },
    ],
  },
  {
    path: '',
    component: Layout,
    hidden: true,
    children: [
      {
        path: '/useredit',
        component: () => import('@/views/useredit/index'),
        name: 'useredit',
        hidden: true,
        meta: {
          keepAlive: false,
        },
      },
    ],
  },
  {
    path: '/selectPoint',
    name: 'selectPoint',
    meta: {
      keepAlive: true,
    },
    component: () => import('@/views/select-point/index'),
    hidden: true,
  },
  { path: '*', redirect: '/404', hidden: true },
]

export const asyncRoutes = []

const createRouter = () => new Router({
  // mode: 'history', // require service support
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRoutes,
})

const router = createRouter()

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter () {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher // reset router
}

export default router
